type DeleteConfirmationParams = { amount: string; currency: string; from: string; to: string };

export const T = {
  en_GB: {
    newAccount: "New account",
    fromAccount: "From account",
    toAccount: "To account",
    amount: "Amount",
    currency: "Currency",
    actions: "Actions",
    addTransfer: "Add transfer",
    cancel: "Cancel",
    edit: "Edit",
    delete: "Delete",
    deleteTransfer: "Delete transfer",
    deleteConfirmation: (p: DeleteConfirmationParams) =>
      `Delete the transfer of ${p.amount} ${p.currency} from ${p.from} to ${p.to}?`,
    noTransfers: "No transfers planned.",
    unknownAccount: "Unknown account",
    error: "Error",
    failedToDelete: "Failed to delete transfer",
  },
  nb_NO: {
    newAccount: "Ny konto",
    fromAccount: "Fra konto",
    toAccount: "Til konto",
    amount: "Beløp",
    currency: "Valuta",
    actions: "Handlinger",
    addTransfer: "Legg til overføring",
    cancel: "Avbryt",
    edit: "Rediger",
    delete: "Slett",
    deleteTransfer: "Slett overføring",
    deleteConfirmation: (p: DeleteConfirmationParams) =>
      `Slette overføringen på ${p.amount} ${p.currency} fra ${p.from} til ${p.to}?`,
    noTransfers: "Ingen planlagte overføringer.",
    unknownAccount: "Ukjent konto",
    error: "Feil",
    failedToDelete: "Kunne ikke slette overføringen",
  },
} as const;
